import _Object$freeze from "@babel/runtime-corejs2/core-js/object/freeze";

/**
 * @return {colorHashcode} for view artwork or detail artwork background color for online room
 */
export default _Object$freeze({
  GREY: '#EAEAEA',
  BLACK: '#000000',
  DARK_GREY: '#B2B0B0',
  WHITE: '#FFFFFF'
});